import { OtherKnowledgeCheckId, ProgramRequestData } from ".";
import { ProgramType } from "../Program/ProgramType";
import { BaseChangeProgramRequestRequest } from "./BaseChangeProgramRequestRequest";

export interface EditProgramRequestRequest extends BaseChangeProgramRequestRequest {
}

export function convertFromProgramRequest(programRequestEdit: ProgramRequestData): EditProgramRequestRequest {
  const convertStringToDate = (dateString: string) => {
    if (dateString) {
      var date = new Date(Date.parse(dateString));
      if (date.getFullYear() > 1900) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      }
    }
    return undefined;
  };
  const convertIssueDate = (dateValue: any) => {
    if (typeof dateValue === 'object') {
      return new Date(Date.UTC(dateValue!.getFullYear(), dateValue!.getMonth(), dateValue!.getDate()));
    }
    var dateFromString = convertStringToDate(dateValue);

    if (dateFromString)
      return dateFromString;

    return new Date(0);
  }

  const request = {
    detailId: programRequestEdit.detailId,
    stateId: programRequestEdit.stateId,
    programTypeId: programRequestEdit.programTypeId,
    programId: programRequestEdit.programId,
    institutionId: programRequestEdit.institutionId,
    qualificationTypeId: programRequestEdit.qualificationTypeId,
    hkoLevelId: programRequestEdit.hkoLevelId,
    educationSectorId: programRequestEdit.educationSectorId,
    educationSubSectorId: programRequestEdit.educationSubSectorId,
    professionId: 0,
    guidedLearningDuration: programRequestEdit.guidedLearningDuration!,
    independentLearningDuration: (programRequestEdit.programTypeId === ProgramType.BasicArtsPrograms
      || programRequestEdit.programTypeId === ProgramType.MiddleSchoolArtsProgramsLongerThanThreeYears
      || programRequestEdit.programTypeId === ProgramType.CroatianLanguageForForeigners) ? 0 : programRequestEdit.independentLearningDuration!,
    workLearningDuration: (programRequestEdit.programTypeId === ProgramType.BasicArtsPrograms
      || programRequestEdit.programTypeId === ProgramType.MiddleSchoolArtsProgramsLongerThanThreeYears
      || programRequestEdit.programTypeId === ProgramType.CroatianLanguageForForeigners) ? 0 : programRequestEdit.workLearningDuration!,
    programName: programRequestEdit.programName ?? "",
    languageLevelGeneralIds: programRequestEdit.languageLevelGeneralIds!,
    languageLevelBusinessIds: programRequestEdit.languageLevelBusinessIds!,
    formsOfTeachingIds: programRequestEdit.formOfTeachingIds!,
    otherFormsOfTeaching: programRequestEdit.otherFormsOfTeaching ?? [],
    knowledgeChecksIds: programRequestEdit.knowledgeChecksIds!,
    otherKnowledgeChecks: programRequestEdit.otherKnowledgeChecks ?? [],
    enrollmentConditionsIds: programRequestEdit.enrollmentConditionsIds,
    otherEnrollmentConditions: programRequestEdit.otherEnrollmentConditions,
    curriculumProgramDocumentId: programRequestEdit.curriculumProgramDocument?.id!,
    locationInsideHeadquarters: programRequestEdit.locationInsideHeadquarters,
    locationOutsideHeadquarters: programRequestEdit.locationOutsideHeadquarters && programRequestEdit.locationOutsideHeadquartersIds && programRequestEdit.locationOutsideHeadquartersIds.length > 0,
    locationOutsideHeadquartersIds: programRequestEdit.locationOutsideHeadquarters ? programRequestEdit.locationOutsideHeadquartersIds : [],
    otherLegalEntityLocations: programRequestEdit.otherLegalEntityLocations ?? [],
    competences: programRequestEdit.competences,
    modules: programRequestEdit.modules.map(
      (mod) => {
        return {
          id: mod.id,
          name: mod.name,
          learningSets: mod.learningSets.map(
            (ls) => {
              return {
                id: ls.id,
                name: ls.name,
                code: ls.code,
                level: ls.level,
                csvet: ls.csvet
              }
            })
        }
      }
    ),
    remark: programRequestEdit.remark,
    remarkInstitution: programRequestEdit.remarkInstitution,
    teachers: programRequestEdit.teachers.map((teacher) => {
      return {
        id: teacher.id,
        programRequestDetailId: programRequestEdit.detailId,
        oib: teacher.oib,
        firstName: teacher.firstName,
        lastName: teacher.lastName,
        statement: teacher.statement,
        diplomaDocument: teacher.diplomaDocument,
        additionalDocumentation: teacher.additionalDocumentation,
        programRequestClassEnsambles: teacher.programRequestClassEnsambles.map((ensamble) => {
          return {
            id: ensamble.id,
            requestTeacherId: teacher.id,
            ensamble: ensamble.ensamble,
          }
        }),
        languages: teacher.languages,
        isLanguageMandatory: teacher.isLanguageMandatory,
        oibChecked: undefined
      }
    }
    ),
    additionalDocumentation: programRequestEdit.additionalDocumentation,
  }
  return request;
}